<!--
/**
* @name: Add.vue
* @description: 直播管理-直播间添加页面
* @author: 杨波
* @create: 2020/12/01 15:16:58
* @update: 2020/12/01 15:16:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-form titleAlign="right" titleWidth="100px" contentWidth="420px">
      <y-form-item title="销售渠道:" required>
        <k-select placeholder="请选择销售渠道" block clearable v-model="editPara.channelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name" :selected="editPara.channelCode == item.code">{{ item.name }}</k-option>
        </k-select>
      </y-form-item>
      <y-form-item title="直播类型:" required>
        <div>
          <k-radio v-model="editPara.type" value="0">手机直播</k-radio>
          <k-radio v-model="editPara.type" value="1">推流设备</k-radio>
          <div :class="css.wrapper">
            <k-icon :class="css.tip_icon" class="k-icon-tip ml-1" color="#999"></k-icon>
            <div :class="css.tip">
              <p>横屏画面：适用于宽高比为“16:9、4:3、1.85:1”的视频</p>
              <p class="mt-1">竖屏画面：适用于适用于宽高比为“9:16、2:3”的视频</p>
            </div>
          </div>
        </div>
      </y-form-item>
      <y-form-item title="直播间名称:" required align="top">
        <k-input placeholder="请输入直播间名称" block clearable v-model="editPara.name"></k-input>
        <div :class="css.desc" class="mt-1">直播间名称必须是4至17字符</div>
      </y-form-item>
      <y-form-item title="直播时间" required align="top">
        <DatePicker type="datetimerange" @on-change="changeDate" :value="liveTime" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择直播时间"></DatePicker>
        <div :class="css.desc" class="mt-1">
          <p>开播时间至少需在10分钟后</p>
          <p>开播时间段仅供参考，不是实际直播间可以开播的时间。</p>
          <p>直播间在开始时间前也可以开播，并且到结束时间后不会强制结束。</p>
          <p>若到结束时间仍未开播，则直播间无法再开播。</p>
        </div>
      </y-form-item>
      <y-form-item title="直播活动简介:" required align="top">
        <k-input placeholder="请输入直播活动简介" tag="textarea" :class="css.textarea" block clearable v-model="editPara.introduce"></k-input>
      </y-form-item>
      <y-form-item title="参与方式:" required>
        <div>
          <k-radio v-model="editPara.participateWay" :value="1">报名参加</k-radio>
          <k-radio v-model="editPara.participateWay" :value="2">适用所有门店</k-radio>
        </div>
      </y-form-item>
      <y-form-item title="主播昵称:" required align="top">
        <k-input placeholder="请输入主播昵称" block clearable v-model="editPara.anchorName"></k-input>
        <div :class="css.desc" class="mt-1">主播昵称，最短2个汉字，最长15个汉字</div>
      </y-form-item>
      <y-form-item title="主播微信帐号:" required align="top">
        <k-select placeholder="请选择主播微信帐号" block clearable v-model="editPara.anchorWechat">
          <k-option v-for="item in memberList" :key="item.userName" :selected="editPara.anchorWechat == item.userName" :value="item.userName" :label="item.userName">{{ item.userName }}</k-option>
        </k-select>
        <div :class="css.desc" class="mt-1">主播微信号，如果未实名认证，需要先前往“小程序直播”进行实名认证</div>
      </y-form-item>
      <y-form-item title="分享卡片:" required align="top">
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedShareCard"></y-upload-file>
          <y-image @delete="onDeleteShareCard" v-dragging="{ list: shareCard, item: img, group: 'image' }" v-for="(img, index) in shareCard" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div :class="css.pic_desc" class="mt-1">图片规则：建议像素800*640，大小不超过1M</div>
      </y-form-item>
      <y-form-item title="背景墙:" required align="top">
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedCoverImg"></y-upload-file>
          <y-image @delete="onDeleteCoverImg" v-dragging="{ list: coverImgList, item: img, group: 'image' }" v-for="(img, index) in coverImgList" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div :class="css.pic_desc" class="mt-1">图片规则：建议像素1080*1920，大小不超过2M</div>
      </y-form-item>
      <y-form-item title="封面图片:" required align="top">
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedFeedsImg"></y-upload-file>
          <y-image @delete="onDeleteFeedsImg" v-dragging="{ list: feedsImgList, item: img, group: 'image' }" v-for="(img, index) in feedsImgList" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div :class="css.pic_desc" class="mt-1">图片规则：建议像素800*800，大小不超过100KB</div>
      </y-form-item>
      <y-form-item title="直播公告:" required align="top">
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedNoticeImg"></y-upload-file>
          <y-image @delete="onDeleteNoticeImg" v-dragging="{ list: noticeImgList, item: img, group: 'image' }" v-for="(img, index) in noticeImgList" :key="index" :index="index" :src="img"></y-image>
        </div>
        <div :class="css.desc" class="mt-1">呈现在app直播专区，用于规则说明。</div>
      </y-form-item>
      <y-form-item title="分享海报:" required align="top">
        <div class="row">
          <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="onUploadedDownloadImg"></y-upload-file>
          <y-image
            @delete="onDeleteDownloadImg"
            v-dragging="{ list: downloadImgList, item: img, group: 'image' }"
            v-for="(img, index) in downloadImgList"
            :key="index"
            :index="index"
            :src="img"
          ></y-image>
        </div>
        <div :class="css.pic_desc" class="mt-1">图片规则：尺寸像素1128*2001</div>
        <div :class="css.desc" class="mt-1">呈现在app直播专区下载海报的位置，用于门店主账号下载后分享给C端用户。</div>
      </y-form-item>
      <y-form-item title="是否自定义订单时效:" required>
        <div>
          <k-radio v-model="isset" :value="0">否</k-radio>
          <k-radio v-model="isset" :value="1">是</k-radio>
        </div>
      </y-form-item>
      <y-form-item title="自动取消订单时间:" required align="top" v-if="isset == '1'">
        <div>
          <k-input @keydown.native="clearInput2" :class="css.inputW" placeholder="请输入" type="number" min="0" block clearable v-model="editPara.orderAutoCancelledTime"></k-input>
          <span class="ml-1">min</span>
        </div>
      </y-form-item>
      <y-form-item>
        <div>
          <div :class="css.query">
            <p>开启点赞：</p>
            <k-switch :class="css.switch" size="small" v-model="editPara.openLike" />
          </div>
          <div :class="css.query">
            <p>开启评论：</p>
            <k-switch :class="css.switch" size="small" v-model="editPara.openComment" />
          </div>
          <div :class="css.query">
            <p>开启回放：</p>
            <k-switch :class="css.switch" size="small" v-model="editPara.openReplay" />
          </div>
          <div :class="css.query">
            <p>开启货架：</p>
            <k-switch :class="css.switch" size="small" v-model="editPara.openGoods" />
          </div>
        </div>
      </y-form-item>
      <y-form-item title="备注:" align="top">
        <k-input placeholder="请输入备注" tag="textarea" :class="css.textarea" block clearable v-model="editPara.remark"></k-input>
      </y-form-item>
    </y-form>
    <div slot="bottom">
      <k-button @click="onCancel(true, false)">取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>
<script>
import {
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_LIST,
  NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_SAVE,
  NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_UPDATE,
  NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_DETAIL_EDIT,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  type: "", // 直播类型
  name: "", //直播间名称
  startTime: "", //直播开始时间
  endTime: "", //直播结束时间
  introduce: "", // 直播活动简介
  participateWay: "", //参与方式
  anchorName: "", //主播昵称
  anchorWechat: "", //主播微信号
  shareImg: "", //分享卡片
  coverImg: "", //背景图
  feedsImg: "", //封面图
  noticeImg: "", //直播公告
  downloadImg: "", //分享海报
  orderAutoCancelledTime: "0", //取消时间
  openLike: "1",
  openComment: "1",
  openReplay: "1",
  openGoods: "1",
  openShare: "0",
  remark: "",
});
export default {
  data() {
    return {
      isLoading: false,
      editPara: initEditPara(),
      channelList: [],
      liveTime: "",
      isset: "",
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      shareCard: [], //分享卡片
      coverImgList: [], //背景图
      feedsImgList: [], //封面图
      noticeImgList: [], //直播公告
      downloadImgList: [], //分享海报
      memberList: [],
      isEdit: false,
      isView: false,
      originData: {},
      isSaving: false,
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let name = para.name.toString().replace(/\s*/g, "");
        let anchorName = para.anchorName.toString().replace(/\s*/g, "");
        if (
          name.length < 2 ||
          name.length > 20 ||
          anchorName.length < 2 ||
          anchorName.length > 20 ||
          (!para.type && para.type != "0") ||
          !this.liveTime ||
          !para.introduce ||
          !para.participateWay ||
          !para.anchorWechat ||
          (this.shareCard && this.shareCard.length === 0) ||
          (this.coverImgList && this.coverImgList.length === 0) ||
          (this.feedsImgList && this.feedsImgList.length === 0) ||
          (this.noticeImgList && this.noticeImgList.length === 0) ||
          (this.downloadImgList && this.downloadImgList.length === 0)
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {
    isset(v) {
      if (!v) {
        this.editPara.orderAutoCancelledTime = "0";
      }
    },
  },
  methods: {
    clearInput2(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-" || key === ".") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    // 分享卡片
    onUploadedShareCard(data) {
      this.shareCard = [];
      this.shareCard.push(data.data[0].url);
    },
    onDeleteShareCard(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.shareCard.splice(obj.index, 1);
        },
      });
    },
    // 背景图
    onUploadedCoverImg(data) {
      this.coverImgList = [];
      this.coverImgList.push(data.data[0].url);
    },
    onDeleteCoverImg(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.coverImgList.splice(obj.index, 1);
        },
      });
    },
    // 封面图
    onUploadedFeedsImg(data) {
      this.feedsImgList = [];
      this.feedsImgList.push(data.data[0].url);
    },
    onDeleteFeedsImg(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.feedsImgList.splice(obj.index, 1);
        },
      });
    },
    // 直播公告
    onUploadedNoticeImg(data) {
      this.noticeImgList = [];
      this.noticeImgList.push(data.data[0].url);
    },
    onDeleteNoticeImg(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.noticeImgList.splice(obj.index, 1);
        },
      });
    },
    // 分享海报
    onUploadedDownloadImg(data) {
      this.downloadImgList = [];
      this.downloadImgList.push(data.data[0].url);
    },
    onDeleteDownloadImg(obj) {
      this.$dialog({
        title: "提示",
        content: "是否确认删除该图片？",
        ok: () => {
          this.downloadImgList.splice(obj.index, 1);
        },
      });
    },
    changeDate(date) {
      this.liveTime = date;
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "liveRoomManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onSave() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.startTime = this.liveTime[0];
      para.endTime = this.liveTime[1];
      para.shareImg = this.shareCard[0];
      para.coverImg = this.coverImgList[0];
      para.feedsImg = this.feedsImgList[0];
      para.noticeImg = this.noticeImgList[0];
      para.downloadImg = this.downloadImgList[0];
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_UPDATE : NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_SAVE,
        para,
      })
        .then((res) => {
          tip("操作成功");
          this.onCancel(true, true);
          this.isSaving = false;
          this.isLoading = false;
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    //获取直播间详情
    getLiveRoomDetail(code) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_BROADCAST_SERVER_BROADCAST_ROOM_DETAIL_EDIT,
        para: { roomCode: code },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.liveTime = [this.editPara.startTime, this.editPara.endTime];
          this.shareCard.push(this.editPara.shareImg);
          this.coverImgList.push(this.editPara.coverImg);
          this.feedsImgList.push(this.editPara.feedsImg);
          this.noticeImgList.push(this.editPara.noticeImg);
          this.downloadImgList.push(this.editPara.downloadImg);
          this.isset = this.editPara.orderAutoCancelledTime ? "1" : "0";
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    //获取主播列表
    getMemberList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_LIST,
        para,
      }).then((res) => {
        this.memberList = res || [];
      });
    },
  },
  created() {
    const { roomCode, edit, view } = this.$route.query;
    this.getMemberList();
    this.getChannelList();
    if (roomCode) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getLiveRoomDetail(roomCode);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { roomCode, edit, view } = to.query;
    this.editPara = initEditPara();
    this.liveTime = "";
    this.isset = "";
    this.shareCard = [];
    this.coverImgList = [];
    this.feedsImgList = [];
    this.noticeImgList = [];
    this.downloadImgList = [];
    if (roomCode) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getLiveRoomDetail(roomCode);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 250px !important;
  display: inline-block !important;
}
.wrapper {
  position: relative;
  display: inline-block;
  & > .tip {
    position: absolute;
    width: 320px;
    height: 80px;
    left: 27px;
    z-index: 10000;
    top: -10px;
    padding: 10px 15px;
    line-height: 20px;
    background-color: #5b5858;
    color: #fff;
    border-radius: 10px;
    display: none;
  }
}
.wrapper:hover {
  cursor: pointer;
}
.wrapper:hover .tip {
  display: block;
}
.desc {
  color: #999;
}
.pic_desc {
  color: rgba(255, 102, 0, 0.423);
}
.query {
  display: inline-block;
  overflow: hidden;
  margin-right: 13px;
  & > p {
    float: left;
  }
  & > .switch {
    width: 35px;
    float: left;
  }
}
.query:last-child {
  margin-right: 0;
}
.textarea {
  width: 420px !important;
  height: 200px;
  & :global(.k-textarea) {
    height: 200px !important;
    resize: none;
  }
}
</style>
